<template>
	<div class="profile-image">
		<div class="profile-image__container">
			<div class="profile-image__logo">
				<div
					v-if="!photo || isEditingLogo"
					class="profile-image__upload"
				>
					<LogoUpload
						:text="$t('loadFile')"
						@change="uploadPhoto"
					/>
				</div>
				<img
					v-else
					class="profile-image__img"
					:src="photo"
				>
			</div>
			<div class="profile-image__controls">
				<vs-button
					:disabled="!photo"
					@click="isEditingLogo = !isEditingLogo"
					class="profile-image__btn w-full pl-1 pr-1"
				>
					{{ isEditingLogo ? $t('cancel') : $t('changePhoto') }}
				</vs-button>

				<vs-custom-button
					v-if="!hideDelete"
					:disabled="!photo"
					@click="photo = ''"
					type="border"
					color="danger"
					class="profile-image__btn w-full pl-1 pr-1"
				>{{ $t('deletePhoto') }}</vs-custom-button>
			</div>
		</div>
	</div>
</template>

<script>
import LogoUpload from "@/components/LogoUpload";

export default {
	name: "ProfileImage",
	props: {
		value: { required: true },
		hideDelete: { type: Boolean, default: false }
	},
	components: {
		LogoUpload
	},
	watch: {
		photo(newValue) {
			if(newValue) {
				this.isEditingLogo = false;
			}
		},
	},
	computed: {
		photo: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			}
		}
	},
	data() {
		return {
			isEditingLogo: false
		};
	},
	methods: {
		uploadPhoto(path, files) {
			this.$emit("uploadPhoto", path, files);
		}
	}
};
</script>

<style lang="scss" scoped>
.profile-image {
	flex: 200px 0 0;
	max-width: 200px;

	&__container {
		width: 100%;
	}

	&__upload {
		width: 100%;
		height: 100%;
	}

	&__btn {
		margin-top: 15px
	}

	&__logo {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 200px;
		height: 200px;
		background-color: #eeeeee;
		border-radius: 10px;
		overflow: hidden;
	}

	&__img {
		width: 100%;
		height: 100%;
	}
}
</style>
